import isClient from 'utils/isClient'
import { ENV } from 'gatsby-env-variables'

function handleInternalTracking(event, props) {
  try {
    if (isClient() && event) {
      if (ENV !== 'prod') {
        console.log('internal tracking', event, props)
      }

      const tagsToSend = ['G-3VDXGSTV7S', 'UA-204852905-1']

      tagsToSend.forEach((tag) => {
        window.gtag('event', event, { ...props, send_to: tag })
      })

      return
    }

    throw new Error('window.gtag or event is not defined')
  } catch (err) {
    console.error('internal tracking', err)
  }
}

export default handleInternalTracking
